import React, { useCallback, useState } from 'react';

import { Select, Wrapper } from '@/components/molecules/filterSelect/FilterSelect.styled';
import { ICodeListItem, IFilter } from '@/types';
import { IconChevronDown } from '@/components/atoms';
import { gaTrackEvent } from '@/helpers';
import { COMPONENT_TYPE } from '@/const';

const FilterSelect = (props: IFilter) => {
  const { options, onClick } = props;
  const [, setSelected] = useState();

  const handleClick = (e: any) => {
    setSelected(e.target.value);
    onClick(e.target.value);
    let text;
    if (e.target.options.selectedIndex > -1) {
      text = e.target.options[e.target.options.selectedIndex].innerHTML;
    }
    gaTrackEvent({
      componentName: COMPONENT_TYPE.FILTER,
      text,
    });
  };

  return (
    <Wrapper>
      <Select onChange={handleClick}>
        {options &&
          options.map((item: ICodeListItem, index: number) => (
            <option key={`option-${index}`} value={item.code}>
              {item.codeNm}
            </option>
          ))}
      </Select>
      <IconChevronDown width={20} color="gray-400" />
    </Wrapper>
  );
};

export default FilterSelect;
